import { retrieveErrors } from "@/lib/api-errors.js";

export function showSuccess(component, text) {
  component.message = { type: "success", text };
}

export function showError(component, errOrText) {
  const text = typeof errOrText === "string" ? errOrText : retrieveErrors(errOrText);
  component.message = { type: "error", text };
}

export function clearMessage(component) {
  component.message = null;
}
